

















import {Component, Ref, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
// @ts-ignore
import * as firebase from 'firebase/app';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;

/* tslint:disable:no-console */
/* tslint:disable:no-empty */

const userNamespace = namespace('userState');

@Component({
  components: {
    BButton,
  },
})

export default class Redeem500Modal extends Vue {
  @userNamespace.State('self') public myself!: MAFUser;
  @userNamespace.Action('purchase') public purchase: any;
  @userNamespace.Action('giftCoinsToSelf') public giftCoinsToSelf!: any;

  public isLoading: boolean = false;

  public redeemOffer() {
    this.buy('first500');
  }

  public async buy(what: string) {
    this.isLoading = true;
    const {res, err} = await this.purchase({what});
    this.isLoading = false;

    if (err) {
      this.$toast.open({message: err, type: 'is-danger', position: 'is-bottom', duration: 2000});
    } else {
      // first 500 get gift of 100 coins
      try {
        await this.giftCoinsToSelf({me: this.myself, gift: 100});
      } catch (error) {
        console.error(error);
      }
      this.closeRedeemModal();
    }
  }

  @Emit('close')
  public closeRedeemModal() {}
}
